import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Segment layout for `/proposals` — list, create and proposal detail render through this Outlet. */
export const Route = createFileRoute('/proposals')({
  component: Outlet,
});
